// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'font-awesome/css/font-awesome.min.css'
import 'vuetify/dist/vuetify.min.css'
import 'v-currency-field/dist/index.css'

import Vue from 'vue'
// import Vuex from 'vuex'
// import VueCookie from 'vue-cookie'
import Vuetify from 'vuetify'
import Currency from 'v-currency-field'
import VChart from 'vue-echarts'
import { use } from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'
import { LineChart, BarChart, PieChart } from 'echarts/charts'
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
  DataZoomComponent,
  ToolboxComponent
} from 'echarts/components'

import App from './App'
import router from './router'
// import Store from './store'
import store from './store'

// import IconComponent from './components/Icon.vue'
// import visa from '../static/cards/visa.svg?inline'
// import discover from '../static/cards/discover.svg?inline'

// @TODO Move theming to component, setup in store, logos
let theme = {
  primary: '#1e62f4',
  secondary: '#e1e1e2',
  accent: '#9900cc',
  error: '#cc0000',
  warning: '#ffeb3b',
  info: '#31393c',
  success: '#23ae62'
}

if (window.location.host.toLowerCase().includes('blueyonder')) {
  theme = {
    primary: '#44a9e2',
    secondary: '#e1e1e2',
    accent: '#e5f1fa',
    error: '#cc0000',
    warning: '#ffeb3b',
    info: '#2196f3',
    success: '#23ae62'
  }
}

if (window.location.host.toLowerCase().includes('atmone')) {
  theme = {
    primary: '#0266a6',
    secondary: '#de9027',
    accent: '#9900cc',
    error: '#cc0000',
    warning: '#ffeb3b',
    info: '#31393c',
    success: '#23ae62'
  }
}

// Vue.use(Vuex)
// Vue.use(VueCookie)

Vue.use(Vuetify, {
  // icons: {
  //   discover,
  //   visa: {
  //     component: visa
  //   }
  // },
  // icons: {
  //   'amex': {
  //     // component: AmexIcon,
  //     props: {
  //       name: 'amex'
  //     }
  //   }
  // },
  options: {
    customProperties: true
  },
  iconfont: 'fa4',
  icons: {
    radioOn: 'fa fa-dot-circle-o',
    radioOff: 'fa fa-circle-o'
  },
  theme
  // theme: { // BlueYonder
  //   primary: '#44a9e2',
  //   secondary: '#e1e1e2',
  //   accent: '#e5f1fa',
  //   error: '#cc0000',
  //   warning: '#ffeb3b',
  //   info: '#2196f3',
  //   success: '#23ae62'
  // }
  // theme: { // Paynetworx
  //   primary: '#1e62fa',
  //   secondary: '#ff6600',
  //   accent: '#9900cc',
  //   error: '#cc0000',
  //   warning: '#ffeb3b',
  //   info: '#31393c',
  //   success: '#23ae62'
  // }
})

Vue.use(Currency)

use([
  CanvasRenderer,
  LineChart,
  BarChart,
  PieChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
  DataZoomComponent,
  ToolboxComponent
])

Vue.component('v-chart', VChart)

Vue.config.productionTip = false

// const store = new Vuex.Store(Store)

// Vue.prototype.$vuetify.theme = {
//   primary: '#3f51b5',
//   secondary: '#b0bec5',
//   accent: '#8c9eff',
//   error: '#ff00ff'
// };

// basic handling of router guard errors
router.onError(error => {
  store.commit('clearErrors')
  store.commit('error', error)
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  render: h => h(App),
  created () {
    let domain = 'paynetworx'
    if (window.location.host.toLowerCase().includes('blueyonder')) {
      domain = 'blueyonder'
    }
    if (window.location.host.toLowerCase().includes('atmone')) {
      domain = 'atmone'
    }
    if (window.location.host.toLowerCase().includes('okdmv')) {
      domain = 'okdmv'
    }
    store.commit('setDomain', domain)
    window.addEventListener('offline', () => {
      store.commit('setConnected', false)
    })
    window.addEventListener('online', () => {
      store.commit('setConnected', true)
    })
  }
})



// WEBPACK FOOTER //
// ./src/main.js